import {
  Component,
  EventEmitter,
  input,
  Input,
  model,
  OnInit,
  output,
  Output,
} from '@angular/core';
import { ELabelType } from '../../types/label';
import { CommonModule } from '@angular/common';
import { Types } from 'shared-lib';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-label',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent implements OnInit {
  tag = model<ELabelType>(ELabelType.TEXT);
  type = model<Types.EAlert>(Types.EAlert.INFO);
  clickable = input(false);
  action = output<void>();

  darkMode = false;

  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
  }

  handleClick() {
    if (this.clickable()) {
      this.action.emit();
    }
  }

  getClass() {
    const baseClass = this.clickable()
      ? 'font-medium cursor-pointer'
      : 'font-medium';
    let sizeClass = '';
    switch (this.tag()) {
      case ELabelType.TITLE:
        sizeClass = 'text-4xl';
        break;
      case ELabelType.SUBTITLE:
        sizeClass = 'text-3xl';
        break;
      case ELabelType.SECTION_TITLE:
        sizeClass = 'text-2xl';
        break;
      case ELabelType.TEXT:
        sizeClass = 'text-sm';
        break;
      case ELabelType.FORM_LABEL:
        sizeClass = 'text-lg';
        break;
      default:
        sizeClass = 'text-base';
    }
    switch (this.type()) {
      case Types.EAlert.INFO:
        return `${baseClass} ${sizeClass} text-blue-500`;
      case Types.EAlert.DANGER:
        return `${baseClass} ${sizeClass} text-red-500`;
      case Types.EAlert.SUCCESS:
        return `${baseClass} ${sizeClass} text-green-500`;
      case Types.EAlert.WARNING:
        return `${baseClass} ${sizeClass} text-yellow-500`;
      case Types.EAlert.DARK:
      case Types.EAlert.LIGHT:
        if (!this.darkMode){
          return `${baseClass} ${sizeClass} text-black`;
        }else{
          return `${baseClass} ${sizeClass} text-white`;
        }
      default:
        return `${baseClass} ${sizeClass}`;
    }
  }
}
